module.exports = __webpack_public_path__ + "img/title.56392975.svg";